import apiForluz, { cardeal } from './api';

export class PlanoParticipanteService {
  obterDadosPlanoAPorMatricula = async (matricula) => {
    const response = await cardeal.get('ObterDadosPlanoA', {
      params: {
        matricula,
      },
    });

    if (response && response.data) {
      return {
        k: response.data.ObterDadosPlanoAResult.K,
        valor: response.data.ObterDadosPlanoAResult.VALOR_CPA,
      };
    }

    return {
      k: '',
      valor: '',
    };
  };

  obterPaginasPorPlano = (plano, statusPlano) =>
    apiForluz.get('ObterLinksExtrato', {
      params: {
        plano,
        statusPlano,
      },
    });

  obterDadosDecimoTerceiro = async (matricula) => {
    const res = await cardeal.get('ObterDadosSolicitacaoPgmtoDecimoTerceiro', {
      params: {
        matricula,
      },
    });

    return res.data;
  };

  obterCertificadoAdesao = async (matricula, token) => {
    const res = await apiForluz.get('ObterCertificadoAdesao', {
      params: {
        matricula,
        token,
      },
      responseType: 'arraybuffer',
    });

    return res.data;
  };

  registrarSolicitacaoPagamento13 = async (matricula, opcao) => {
    const res = await cardeal.post('RegistrarSolicitacaoPagamento13', {
      matricula,
      opcao,
    });

    return res.data;
  };
}
